// @ts-expect-error: @rails/request.js is not typed
import { FetchRequest } from '@rails/request.js'
import { useMutation } from '@tanstack/react-query'

import { type ProspectEmployee } from 'components/prospects/types'

import { useEmbeddedOnboarding } from '../employer_onboarding/useEmbeddedOnboarding'
import { GrapeAPIError, type GrapeAPIErrorType } from '../GrapeAPIError'

type CreateProspectEmployeeParams = Omit<ProspectEmployee, 'id' | 'rating_area_code'>

export type BulkCreateProspectEmployeesParams = {
  census_id: string
  employees: CreateProspectEmployeeParams[]
  overwrite_existing?: boolean
}

export function useBulkCreateProspectEmployees ({ prospectId }: { prospectId: string }) {
  const { embeddedOnboardingToken: token } = useEmbeddedOnboarding()
  return useMutation<ProspectEmployee[], GrapeAPIErrorType, BulkCreateProspectEmployeesParams>({
    mutationFn: async (params: BulkCreateProspectEmployeesParams) => {
      const request = new FetchRequest(
        'post',
        `/api/web/quoting/prospects/${prospectId}/census/${params.census_id}/employees/bulk_create`,
        {
          body: {
            employees: params.employees,
            overwrite_existing: params.overwrite_existing,
          },
          headers: token ? { 'Thatch-Onboarding-Session-Client-Secret': token } : {},
        }
      )
      const response = await request.perform()
      if (!response.ok) {
        const errors = await response.json
        throw GrapeAPIError({
          status: response.status,
          message: errors.message,
          errors: errors.errors,
          fieldErrors: errors.field_errors,
        })
      }
      return response.json
    },
  })
}
